var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            xl: _vm.columnSizes.areaCode.lg,
            lg: _vm.columnSizes.areaCode.lg,
            md: _vm.columnSizes.areaCode.md,
            sm: _vm.columnSizes.areaCode.sm,
            cols: _vm.columnSizes.areaCode.xs,
          },
        },
        [
          _c("child-dynamic-element", {
            attrs: {
              formName: _vm.formName,
              element: Object.assign(
                {},
                {
                  type: "SingleSelect",
                  identifier: _vm.ids.areaCode,
                  name: _vm.ids.areaCode,
                },
                _vm.areaCode
              ),
              optional: !_vm.required && _vm.phoneValue.length <= 0,
              required: _vm.required || _vm.phoneValue.length > 0,
            },
            model: {
              value: _vm.areaCodeValue,
              callback: function ($$v) {
                _vm.areaCodeValue = $$v
              },
              expression: "areaCodeValue",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        {
          attrs: {
            xl: _vm.columnSizes.phone.lg,
            lg: _vm.columnSizes.phone.lg,
            md: _vm.columnSizes.phone.md,
            sm: _vm.columnSizes.phone.sm,
            cols: _vm.columnSizes.phone.xs,
          },
        },
        [
          _c("child-dynamic-element", {
            attrs: {
              formName: _vm.formName,
              element: Object.assign(
                {},
                { type: "Text", identifier: _vm.ids.phone },
                _vm.phone
              ),
              optional: !_vm.required && _vm.areaCodeValue.length <= 0,
              required: _vm.required || _vm.areaCodeValue.length > 0,
            },
            model: {
              value: _vm.phoneValue,
              callback: function ($$v) {
                _vm.phoneValue = $$v
              },
              expression: "phoneValue",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }